exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\nbutton[data-v-84feda02] {background:var(--theme-primary) !important\n}\nbutton[data-v-84feda02] { height: 32px !important; color: #fff !important\n}\n.get-logs[data-v-84feda02]{\npadding: 8px 15px;\n    height: 36px !important;\n    margin-top: -2px;\n}\nth[data-v-84feda02], td[data-v-84feda02]{\n    padding: 5px 5px !important;\n\tfont-size:14px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-84feda02","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/SystemLogs.vue
// module id = 623
// module chunks = 1